module.exports = __webpack_public_path__ + "Flag-800.79ee748442393eafe2191e1e96d7ce3f.svg";